{
  "nav": {
    "mainNavigation": "Main navigation",
    "sectionSettings": "Settings",
    "settings": "Settings",
    "users": "Users",
    "groups": "Groups",
    "reports": "Reports",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "toggleSidebarHint": "Toggle navigation",
    "overview": "Overview",
    "accounts": "Debtors",
    "trash": "Trash",
    "debtsSettings": "Debts settings"
  },
  "sidebar": {
    "toggle": "Toggle sidebar",
    "toggleHint": "Show or hide the menu",
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "brand": "Al-Musafer"
}
